import { render, staticRenderFns } from "./PaginationNavArray.vue?vue&type=template&id=852482b0"
import script from "./PaginationNavArray.vue?vue&type=script&lang=js"
export * from "./PaginationNavArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports